import { render, staticRenderFns } from "./VantActivitySixOneEightPop.vue?vue&type=template&id=5e8d24c8&"
import script from "./VantActivitySixOneEightPop.vue?vue&type=script&lang=js&"
export * from "./VantActivitySixOneEightPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports